import React, { useContext, useState } from 'react';
import { SearchIcon } from 'glints-aries';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { defineMessage, useIntl } from 'react-intl';

import DisableIOSZoomingMeta from 'src/common/platformUtils/DisableIOSZoomingMeta';
import { StringUtils } from 'src/common/utils/stringUtils';
import { SEOSlugUrlParams } from 'src/modules/Opportunities/pages/Explore/Components/FilterSection/context';
import * as S from 'src/modules/Opportunities/pages/Explore/Components/SearchSection/SearchSectionMobile/MainSearchField.sc';
import { SearchRouterQueryKey } from 'src/modules/Opportunities/pages/Explore/types';

const SearchModal = dynamic(() =>
  import(
    'src/modules/Opportunities/pages/Explore/Components/SearchSection/SearchSectionMobile/SearchModal'
  ).then((module) => module.SearchModal)
);

type Props = {
  onOpenModal?: () => void;
  onCloseModal?: () => void;
};

export const MainSearchField: React.FC<React.PropsWithChildren<Props>> = ({
  onOpenModal,
  onCloseModal,
}) => {
  const intl = useIntl();
  const [showModal, setShowModal] = useState<boolean>(false);
  const router = useRouter();
  const {
    [SearchRouterQueryKey.Location]: locationName = '',
    [SearchRouterQueryKey.Keyword]: keywords = '',
    [SearchRouterQueryKey.Keywords]: keywordsQuery = '',
  } = router.query;
  const internalQueryAndFilterSearchKeyword =
    StringUtils.convertOtherCaseToTitleCase(
      StringUtils.convertQueryToSingleString(keywordsQuery)
    );
  const { customSlugPageKeyword } = useContext(SEOSlugUrlParams);

  const value =
    (keywords ||
      customSlugPageKeyword ||
      internalQueryAndFilterSearchKeyword ||
      '') +
    (keywords || locationName ? ' Jobs ' : '') +
    (locationName ? `In ${locationName}` : '');

  const onClick = () => {
    setShowModal(true);

    if (onOpenModal) {
      onOpenModal();
    }
  };

  const onClose = () => {
    setShowModal(false);

    if (onCloseModal) {
      onCloseModal();
    }
  };

  return (
    <>
      <DisableIOSZoomingMeta />
      {showModal && <SearchModal onClose={onClose} isVisible={showModal} />}
      <S.TextField
        type="text"
        label={intl.formatMessage(
          defineMessage({
            id: 'job_explore_page.search_for_jobs',
            defaultMessage: 'Search for jobs',
          })
        )}
        removeFloatingLabel={true}
        startIcon={<SearchIcon />}
        onClick={onClick}
        value={value}
      />
    </>
  );
};
